import { startOfDay } from 'date-fns'

const areDatesConflicting = (
  s1: Date,
  e1: Date | null,
  s2: Date,
  e2: Date | null,
) => {
  if (!e1 || !e2 || !s1 || !s2) return false

  const ns1 = startOfDay(s1)
  const ns2 = startOfDay(s2)
  const ne1 = startOfDay(e1)
  const ne2 = startOfDay(e2)

  if (ns1 <= ns2) {
    if (ne1 > ns2) return true
  } else {
    if (ne2 > ns1) return true
  }

  return false
}

export { areDatesConflicting }
